var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 6C13.25 3.65279 11.3472 1.75 9 1.75C6.65279 1.75 4.75 3.65279 4.75 6C4.75 8.34721 6.65279 10.25 9 10.25C11.3472 10.25 13.25 8.34721 13.25 6ZM14.75 6C14.75 8.02499 13.7021 9.8037 12.1201 10.8281C13.2598 11.2633 14.3082 11.9332 15.1875 12.8125C16.8284 14.4534 17.75 16.6794 17.75 19C17.75 19.4142 17.4142 19.75 17 19.75C16.5858 19.75 16.25 19.4142 16.25 19C16.25 17.0772 15.4866 15.2327 14.127 13.873C12.8523 12.5984 11.1514 11.8477 9.35938 11.7588L9 11.75C7.07718 11.75 5.23269 12.5134 3.87305 13.873C2.51341 15.2327 1.75 17.0772 1.75 19C1.75 19.4142 1.41421 19.75 1 19.75C0.585786 19.75 0.25 19.4142 0.25 19C0.25 16.6794 1.17156 14.4534 2.8125 12.8125C3.69155 11.9334 4.73956 11.2633 5.87891 10.8281C4.29734 9.80363 3.25 8.02469 3.25 6C3.25 2.82436 5.82436 0.25 9 0.25C12.1756 0.25 14.75 2.82436 14.75 6Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg16);
export default __webpack_public_path__ + "static/media/svg16.7eddb443dc7e8cf1c6208ded99d593a9.svg";
export { ForwardRef as ReactComponent };